<template>
    <v-breadcrumbs class="pa-0" :items="items">
        <template #item="{ item, index }" :key="index">
            <v-breadcrumbs-item class="text-meta text-grey-darken-3 cursor-pointer" @click="router.push(item.to)" :disabled="index === items.length - 1" :title="item.title"></v-breadcrumbs-item>
        </template>
    </v-breadcrumbs>
</template>

<script setup>
const router = useRouter();
const route = useRoute();
const items = computed(() => {
    return [''].concat(
        route.path.split('/')
            .filter(Boolean)
    )
        .map((item, index, array) => array.slice(0, index).join('/') + '/' + item)
        .map(x => router.resolve(x))
        .filter(x => x.name !== '/[...path]')
        .map(x => Object.assign({}, {
            title: x.matched.at(-1).components.default?.title,
            to: x,
        }));
});
</script>
